import type { ChatAgentScope } from "@/app/providers/ChatAgentScopeContext";

/**
 * Where a chat send goes: the scoped agent/run's conversation when set, otherwise
 * the active conversation. When `scope` is null (the default) — or the scope has
 * no `conversationId` (e.g. fixtures) — this returns exactly `activeConversationId`,
 * i.e. the pre-scope behavior, so the unscoped chat path is byte-identical.
 */
export function resolveSendConversationId(
  scope: ChatAgentScope | null,
  activeConversationId: string | undefined,
): string | undefined {
  return scope?.conversationId ?? activeConversationId;
}
